import _ from "lodash"
import { getPsid, getUrlParams } from "../../configs/utils"

const params = getUrlParams()

console.log('InitialState - All URL params:', params)
console.log('InitialState - autoStartChat param:', params.autoStartChat)
console.log('InitialState - autoStartChat value will be:', params.autoStartChat === "true")

const initialState = {
  socketRequestProcessing: false,
  isSocketConnected: false,
  psid: getPsid(params.isPlaygroundInstance === "true" && !_.isEmpty(params.playgroundInstanceId)),
  tenantId: params.tenantId,
  isTestBot: params.testBot === "true",
  sessionId: null,
  startNewSession: true,
  messages: [],
  welcomeMessages: [],
  unReadMessages: [],
  quickReplies: [],
  autoSuggestQuickReplies: [],
  isBotOpen: false,
  modalLoading: false,
  snackbarProps: { open: false },
  routeBasedNotifications: {},
  enableLiveChatButton: false,
  typingInfo: {},
  chatStatus: null,
  firstUnreadMessageId: "",
  knowledgeSource: {},
  showKnowledgeSource: false,
  relay: {
    payload: {},
    data: []
  },
  userLoginData: {},
  chatHistoryData: null,
  hasChatEnded: false,
  recentChat: null,
  autoStartChat: params.autoStartChat === "true",
  playgroundInstanceSettings: {
    active: params.isPlaygroundInstance === "true" && !_.isEmpty(params.playgroundInstanceId),
    ...(params.isPlaygroundInstance === "true" && !_.isEmpty(params.playgroundInstanceId) && {
      instanceId: params.playgroundInstanceId,
    }),
    sync: params.isPlaygroundInstance === "true" && !_.isEmpty(params.playgroundInstanceId),
    botSettings: {},
  }
}

export default initialState
